import authApi from "@/api/auth";
import commonActionHandle from "@/commonActionHandle";
import { GPURENTAL_STATUS_CODE } from "@/constant/config";
import baseComponent from '@/scripts/baseComponent';
import VueRecaptcha from 'vue-recaptcha';
const homepage = process.env.VUE_APP_HOMEPAGE;
const enableRecaptcha = (process.env.VUE_APP_ENABLED_RECAPTCHA == 'true');

export default {
    props: {
        location: {
            type: String,
            default: null
        },
    },
    extends: baseComponent,
    components: { VueRecaptcha },

    data() {
        return {
            homepage: homepage,
            delayNotification: 1000,
            isLoading: false,
            enabledRecaptcha: enableRecaptcha,
            forgotPasswordForm: {
                email: "",
                deviceInformation: '',
                recaptchaToken: "",
            },
            rules: {
                email: [
                    {
                        required: true,
                        message: this.$lang.forgotPassword.validationRequiredEmail,
                        trigger: "blur"
                    },
                    {
                        type: "email",
                        message: this.$lang.forgotPassword.validationTypeEmail,
                        trigger: ["blur", "change"]
                    }
                ]
            }
        };
    },

    computed: {
        canExecute() {
            return (!this.enabledRecaptcha || this.forgotPasswordForm.recaptchaToken !== '');
        }
    },
    methods: {

        // Submit form forgot password
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.isLoading = true;
                    this.forgotPasswordForm.deviceInformation = JSON.stringify(this.getInformationClient());
                    authApi
                        .forgotPasswordUser(this.forgotPasswordForm)
                        .then(res => {
                            setTimeout(() => {
                                try {
                                    this.isLoading = false;
                                    switch (res.errorCode) {
                                        case GPURENTAL_STATUS_CODE.ForgotPassword_Success:
                                            commonActionHandle.showCustomSuccess(
                                                this.$lang.dialog.success,
                                                `A recovery e-mail has been sent to ${this.forgotPasswordForm.email} , please check and follow the instructions written in the e-mail.`,
                                                this.postRecoverySuccess
                                            );
                                            break;
                                        default:
                                            this.resetRecaptcha();
                                            this.$store.dispatch("common/showUnkownError", res, 'Password recovery failed ...');
                                            break;
                                    }
                                } catch (error) {
                                    this.resetRecaptcha();
                                    this.$store.dispatch("common/showUnkownError", error, 'Password recovery failed ...');
                                }
                            }, this.delayNotification);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                try {
                                    this.isLoading = false;
                                    if (error.name === 'Error') {
                                        this.resetRecaptcha();
                                        this.$store.dispatch("common/showCommonError", error);
                                    } else {
                                        commonActionHandle.showCustomWarning(
                                            'Password recovery failed ...',
                                            "We couldn't find your account with that information."
                                        );
                                        this.resetRecaptcha();
                                    }
                                } catch (error) {
                                    this.resetRecaptcha();
                                    this.$store.dispatch("common/showUnkownError", error, 'Password recovery failed ...');
                                }
                            }, this.delayNotification);
                        });
                } else {
                    this.isLoading = false;
                    return false;
                }
            });
        },

        // Post recovery password success
        postRecoverySuccess() {
            this.openComponentView('Login');
        },

        verifyRecaptcha(response) {
            //console.log("verifyRecaptcha", response);
            this.$set(this.forgotPasswordForm, "recaptchaToken", response);
        },
        expiredRecaptcha() {
            //console.log("expiredRecaptcha");
            if (this.enabledRecaptcha) {
                this.$set(this.forgotPasswordForm, "recaptchaToken", "");
                if (this.$refs.recaptchaComp) this.$refs.recaptchaComp.reset();
                this.enabledRecaptcha = false;
                this.enabledRecaptcha = process.env.VUE_APP_ENABLED_RECAPTCHA;
            }
        },
        renderRecaptcha(id) {
            //console.log("renderRecaptcha", id);
        },
        errorRecaptcha() {
            //console.log("errorRecaptcha");
        },
        resetRecaptcha() {
            if (this.enabledRecaptcha) {
                this.$set(this.forgotPasswordForm, "recaptchaToken", "");
                this.$refs.recaptchaComp.reset();
                this.enabledRecaptcha = false;
                this.enabledRecaptcha = process.env.VUE_APP_ENABLED_RECAPTCHA;
            }
        },
        // Open component view
        openComponentView(componentName) {
            this.$emit("openComponentView", componentName);
        }
    }
};